
import { butter } from "~/plugins/buttercms";
import ProductFetchMixin from "~/mixin/product-fetch-mixin";

export default {
  name: "cal-same-address-delivery",
  mixins: [ProductFetchMixin],
  data() {
    return {
      toggleYes: this.$store.state.cartItem.sameDayDelivery.toggleYes,
      currOrdersInCart: [] as any[],
      selectedOrderToRepeat: this.$store.state.cartItem.sameDayDelivery.currSameAddressOrder,
      isSameAddressOrder: this.$store.state.cartItem.sameDayDelivery.isSameAddressOrder,
      recipient: { ...this.$store.state.cartItem.recipient },
      pageData: {},
      listOfCurrAddresses: [] as any[],
      selectedOrderToRepeatText: ""
    };
  },
  watch: {
    toggleYes() {
      this.validateUserSelections();
      this.$nuxt.$emit("toggleSameAddressOrder", this.toggleYes == "Yes");
    },
    selectedOrderToRepeatText() {
      this.validateUserSelections();
      let recipientDetails = this.currOrdersInCart.find(order => order.recipientDetails.address === this.selectedOrderToRepeatText);
      this.$nuxt.$emit("toggleSameAddress", recipientDetails);
    },
  },
  computed: {
    addressesFromCart() {
      return Object.values(this.listOfCurrAddresses);
    }
  },
  created() {
    this.$nuxt.$emit("sameOrderDisabled", true);
    this.getItemsInCart();
    if (this.currOrdersInCart && this.currOrdersInCart.length === 1) {
      this.selectedOrderToRepeatText = this.currOrdersInCart[0]?.recipientDetails?.address ?? "";
    } else {
      this.selectedOrderToRepeatText = "";
    }

    this.$nuxt.$on("loadSameAddressDelivery", () => {
      this.recipient = this.$store.state.cartItem.recipient;
      this.getItemsInCart();
      if (this.currOrdersInCart && this.currOrdersInCart.length === 1) {
        this.selectedOrderToRepeatText = this.currOrdersInCart[0]?.recipientDetails?.address ?? "";
      } else {
        this.selectedOrderToRepeatText = "";
      }
    });

    this.$nuxt.$on("scrollToSameAddress", () => {
      const sameAddressEl = document.getElementById('same-address');
      if (sameAddressEl) {
        sameAddressEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    this.validateUserSelections();
  },
  methods: {
    getClipartImage() {
      const itemsInCart = sessionStorage.cartItems
        ? JSON.parse(sessionStorage.cartItems)
        : null;

      if(itemsInCart && Object.keys(itemsInCart).length < 2) {
        return this.pageData["clipart1"];
      }
      else if(itemsInCart && Object.keys(itemsInCart).length < 3){
        return this.pageData["clipart2"];
      }
      else if(itemsInCart && Object.keys(itemsInCart).length < 4){
        return this.pageData["clipart3"];
      }
      else if(itemsInCart && Object.keys(itemsInCart).length >= 4){
        return this.pageData["clipart4"];
      }
      else{
        return this.pageData["clipart1"];
      }
    },
    validateUserSelections() {
      if (this.toggleYes == "Yes" && this.selectedOrderToRepeatText !== "") {
        this.selectedOrderToRepeat = this.currOrdersInCart.find(order => order.recipientDetails.address === this.selectedOrderToRepeatText);
        this.$store.dispatch("cartItem/SET_IS_SAME_ADDRESS_ORDER", true);
        this.$store.dispatch("cartItem/SET_CURR_SAME_ADDRESS_ORDER", this.selectedOrderToRepeat);
        this.$store.dispatch("cartItem/SET_CURR_SAME_ADDRESS_TOGGLE", this.toggleYes);
        this.setRecipientInfo(this.selectedOrderToRepeat["recipientDetails"]);
        this.$nuxt.$emit("sameOrderDisabled", false);
      } else if (this.toggleYes == "No") {
        this.$store.dispatch("cartItem/SET_IS_SAME_ADDRESS_ORDER", false);
        this.$store.dispatch("cartItem/SET_CURR_SAME_ADDRESS_ORDER", null);
        this.$store.dispatch("cartItem/SET_CURR_SAME_ADDRESS_TOGGLE", this.toggleYes);
        this.$nuxt.$emit("sameOrderDisabled", false);
      } else {
        this.$nuxt.$emit("sameOrderDisabled", true);
      }
    },
    setRecipientInfo(sameAddressInfo: any) {
      this.recipient.firstName = sameAddressInfo.firstName;
      this.recipient.lastName = sameAddressInfo.lastName;
      this.recipient.address = sameAddressInfo.address;
      this.recipient.city = sameAddressInfo.city;
      this.recipient.postalCode = sameAddressInfo.postalCode;
      this.recipient.deliveryNote = sameAddressInfo.deliveryNote;
      this.recipient.buzzerCode = sameAddressInfo.buzzerCode;
      this.recipient.province = sameAddressInfo.province;
      this.recipient.addressType = sameAddressInfo.addressType;
      this.recipient.apartment = sameAddressInfo.apartment;
      this.recipient.buzzerCode = sameAddressInfo.buzzerCode;
      this.$store.dispatch("cartItem/RECIPIENT_ADD", { ...this.recipient });
    },
    getItemsInCart() {
      this.currOrdersInCart = [];
      const currRegion = Object.keys(this.$store.state.cartItem.deliveryTown).length > 0
        ? this.$store.state.cartItem.deliveryTown.regionName
        : null;

      const currDeliveryDate = this.$store.state.cartItem.deliveryDate.length > 0
        ? this.$store.state.cartItem.deliveryDate
        : null;

      const existingSessionCartItems = sessionStorage.cartItems
        ? JSON.parse(sessionStorage.cartItems)
        : null;
      if (existingSessionCartItems) {
        for (const key of Object.keys(existingSessionCartItems)) {
          if (
            existingSessionCartItems[key].deliveryWindow.deliveryDate ===
              currDeliveryDate &&
            existingSessionCartItems[key].deliveryWindow.deliveryRegion ===
              currRegion
          ) {
            let item = {
              deliveryWindow: existingSessionCartItems[key].deliveryWindow,
              recipientDetails: existingSessionCartItems[key].recipient,
            };

            if (
              !this.listOfCurrAddresses.includes(
                existingSessionCartItems[key].recipient.address
              )
            ) {
              this.listOfCurrAddresses.push(
                existingSessionCartItems[key].recipient.address
              );
              this.currOrdersInCart.push(item);
            }
          }
        }
      }
    },
  },
  async fetch() {
    try {
      const page = await butter(this.$config).page.retrieve(
        "*",
        "same-address-delivery-dialog",
        {
          locale: this.$i18n.locale,
        }
      );
      this.pageData = page?.data.data.fields;
    } catch (error) {
      console.error(error);
    }
  },
};
